import { render, staticRenderFns } from "./blogcategory.vue?vue&type=template&id=bb1f6c08&"
import script from "./blogcategory.vue?vue&type=script&lang=js&"
export * from "./blogcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports